import createTemplateService from './createTemplateServjce';
const researcherConfidentialTemplateService = createTemplateService('/researcher_confidential_templates');
export default researcherConfidentialTemplateService;